import { Contact } from "./User";

export interface Company {
  id: number;
  name: string;
  organization_number?: string,
  brreg_parent_id?: number,
  allow_employments?: boolean,
  salary_deduction_instance?: string,
  primary_contact_id?: number,
  company_group_id?: number,
  external_id?: string,

  primary_contact?: Contact,
  company_group?: CompanyGroup,

  company_contacts?: CompanyContact[],
  company_addresses?: CompanyAddress[],
}

export const newCompany = (): Company => {
  return {
    id: 0,
    name: "",
  }
};

export interface CompanyGroup {
  id: number;
  name: string;
}

export interface CompanyContact {
  id: number;
  name: string;
  company_id: number;
  contact_id: number;
  main_contact: boolean;
  contact_name?: string;
  company_name?: string;
}

export const newCompanyContact = (): CompanyContact => {
  return {
    id: 0,
    name: "",
    company_id: 0,
    contact_id: 0,
    main_contact: false,
  }
};

export interface CompanyAddress {
  id: number;
  address_id: number;
  company_id: number;
  valid_from?: Date;
  valid_to?: Date;
  primary_address: boolean;
  addressline1?: string;
  addressline2?: string;
  addressline3?: string;
  postcode?: string;
  postoffice?: string;
  company_name?: string;
}

export const newCompanyAddress = (): CompanyAddress => {
  return {
    id: 0,
    address_id: 0,
    company_id: 0,
    valid_from: null,
    valid_to: null,
    primary_address: false,
    addressline1: "",
    addressline2: "",
    addressline3: "",
    postcode: "",
    postoffice: "",
    company_name: "",
  }
};